var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var PartStyle;
(function (PartStyle) {
    PartStyle["bold"] = "bold";
})(PartStyle || (PartStyle = {}));
export var mapSentence = function (sentence) { return ({
    parts: sentence.parts.map(function (part) { return (__assign(__assign({}, part), { styles: new Set(part.styles) })); }),
}); };
